export default __webpack_public_path__ + "static/media/hover-imatge-empatitzant@2x.577f29f2.jpg";